export default __webpack_public_path__ + "static/media/download-white.979ac810.svg";